import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/controls/button";
import Style from "./Login.module.scss";
import { useHistory } from "react-router";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import getItemFromLocalStorage from "../../../utils/getItemFromLocalStorage";
import CustomInput from "../../../components/controls/input/customInput/CustomInput";
import Checkbox from "../../../components/controls/checkbox/Checkbox";
import ForgotButton from "../../../components/controls/button/TransparentButton";
import Cookies from "js-cookie";
import HanshiLogin from "../../../assets/hanshi/login-hanshi-no-background.png";
import { handleLogout, isTokenValid } from "../../../store/services/service";
import {
  setEncryptedCookie,
  getDecryptedCookie,
  removeCookie,
} from "../../../utils/cookieUtils";
import api from "../../../store/services/auth.service";
import Phone from "../../../components/controls/input/phoneInput/PhoneInput";
import { checkEmail, isValidEmail } from "../../../utils/formValidation";
import { ArrowLeft } from "../../../modules/default-svg";
import Turnstile, { TURNSTILE_TOKEN_HEADER } from "../../../components/turnstile/Turnstile";

const Login = (props) => {
  const {
    loginRequest,
    fetchLogoRequest,
    resetErrorMesage,
    authError,
    isLoading,
    isMfaRequired,
    isMfaSetupRequired,
    isPasswordResetRequired
  } = props;
  const history = useHistory();
  const envr = process.env.REACT_APP_ENV;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checked, setChecked] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const token = localStorage.getItem("accessToken");
  const domain = getDecryptedCookie("domain");
  const [companyName, setCompanyName] = useState("");
  const [isCompanyName, setIsCompanyName] = useState(false);
  const [companyNameError, setCompanyNameError] = useState("");
  // const [logo, setLogo] = useState(null); 

  //Demo States
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isDemoRequestCompleted, setIsDemoRequestCompleted] = useState(false);
  const [demoFullName, setDemoFullName] = useState("");
  const [demoPhoneNumber, setDemoPhoneNumber] = useState("");
  const [demoCompanyName, setDemoCompanyName] = useState("");
  const [demoEmail, setDemoEmail] = useState("");
  const [demoDateTime, setDemoDateTime] = useState(null);
  const [demoMessage, setDemoMessage] = useState("");
  const [demoErrors, setDemoErrors] = useState({});
  const [demoTurnstileToken, setDemoTurnstileToken] = useState(null);
  const demoTurnstileRef = useRef(null);

  // Demo Time restrictions: 8 AM to 6 PM
  const MIN_HOUR = 8;
  const MAX_HOUR = 18;
  const MAX_MESSAGE_LENGTH = 1000;

  const handleSetCookie = () => {
    setEncryptedCookie("domain", companyName);
  };


  useEffect(() => {
    if(!isLoading){
      if (isPasswordResetRequired) {
        history.push("/reset-password");
        return;
      }
      if (isMfaSetupRequired) {
        history.push("/mfa-setup");
        return;
      }
      if (isMfaRequired) {
        history.push("/verify-mfa");
        return;
      }
    }
  }, [isMfaRequired, isMfaSetupRequired, isPasswordResetRequired]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const demoParam = queryParams.get("demo-request");
    const tenantParam = queryParams.get("tenant");
    const tenantDomain = tenantParam ?? domain;

    if (demoParam == "") {
      setIsDemoMode(true);
      setIsDemoRequestCompleted(false);
      queryParams.delete("tenant");
      window.history.replaceState(null, "", window.location.pathname);
    }
    else {
      if (tenantDomain) {
        setIsCompanyName(true);
        setCompanyName(tenantDomain);
      }

      if (tenantParam) {
        queryParams.delete("tenant");
        window.history.replaceState(null, "", window.location.pathname);
      }
    }


  }, []);

  useEffect(() => {
    if (isCompanyName) {
      //fetchCompanyLogo();
      handleCompanyName();
    }
  }, [isCompanyName]);

  const handleRemoveCookie = () => {
    removeCookie("domain");
    setIsCompanyName(false);
    setCompanyName("");
    setCompanyNameError("");
    //setLogo(null);
  };

  const handleCheckboxChange = () => {
    setRememberMe(!rememberMe);
    setChecked(!checked);
  };

  useEffect(() => {
    resetErrorMesage();
  }, []);

  useEffect(() => {
    const email = getDecryptedCookie("email");
    const password = getDecryptedCookie("password");;
    if (email && password) {
      setEmail(email);
      setPassword(password);
    }
  }, []);

  const handleLogin = async () => {
    if (
      (email?.length < 1,
        password?.length < 1,
        emailError?.length > 0,
        isLoading)
    ) {
      return;
    }

    if (rememberMe) {
      setEncryptedCookie("rememberMe", "true");
    }
    else {
      removeCookie("rememberMe");
    }

    const user = getItemFromLocalStorage("user");
    if (user === null) {
      loginRequest({
        Login: email,
        password,
        rememberMe,
        checked,
        domain,
      });
    } else {
      history.go(0);
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      if (email && password) {
        await handleLogin();
      }
    }
  };

  const handleCompanyName = () => {
    if (companyName) {
      setIsCompanyName(true);
      //fetchCompanyLogo();
      handleSetCookie();
      setCompanyNameError("");
    } else {
      setCompanyNameError("Please enter your organization domain");
    }
  };
  const handleKeyDownCompanyName = (event) => {
    if (event.key === "Enter") {
      handleCompanyName();
    }
  };

  const handleForgotPassword = () => {
    history.push("/forgot-password");
  };

  const toggleDemoMode = () => {
    setCompanyNameError("");
    setEmailError("");
    setDemoErrors({});
    setDemoFullName("");
    setDemoCompanyName("");
    setDemoPhoneNumber("");
    setDemoEmail("");
    setDemoDateTime(null);
    setDemoMessage("");
    setDemoTurnstileToken(null);
    setIsDemoMode(!isDemoMode);
    setIsDemoRequestCompleted(false);
  };

  useEffect(() => {
    const isRememberMe = getDecryptedCookie("rememberMe") === "true";
    const tokenValid = isTokenValid();
    if (tokenValid) {
      history.push(`${envr}/dashboard`);
    }

    if (isRememberMe) {
      setChecked(true);
      setRememberMe(true);
    }


  }, []);

  useEffect(() => {
    if (authError) {
      setEmailError(authError?.error);
    } else {
      setEmailError("");
    }
  }, [authError]);

  useEffect(() => {
    if (email.length > 0 && password.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [email, password]);

  useEffect(() => {
    if (token) {
      history.push(`${envr}/dashboard`);
    }
  }, [token]);

  const validateEmail = (e) => {
    setDemoErrors((prevErrors) => ({
      ...prevErrors,
      Email: !isValidEmail(e.target.value) ? "Invalid Email" : "",
    }));
  };

  const handleDemoEmailChange = (email) => {
    setDemoEmail(email);
    setDemoErrors((prevErrors) => ({
      ...prevErrors,
      Email: "",
    }));
  }
  const ValidateDemoRequestDate = () => {
    let errors = {};

    if (!demoFullName || demoFullName.trim().length === 0) {
      errors.FullName = " ";
    }

    if (!demoCompanyName || demoCompanyName.trim().length === 0) {
      errors.CompanyName = " ";
    }

    if (!demoEmail || demoEmail.trim().length === 0 || !isValidEmail(demoEmail)) {
      errors.Email = "Invalid Email";
    }

    if (!demoDateTime) {
      errors.DateTime = "Please select a time that works best for your demo";
    } else {
      // Validate time is within allowed range
      const hours = moment(demoDateTime).hours();
      if (hours < MIN_HOUR || hours >= MAX_HOUR) {
        errors.DateTime = `Please select a time between ${MIN_HOUR}:00 and ${MAX_HOUR}:00`;
      }
      
      // Validate it's not in the past
      if (moment(demoDateTime).isBefore(moment())) {
        errors.DateTime = "Please select a future date and time";
      }
    }

    if (demoMessage && demoMessage.length > MAX_MESSAGE_LENGTH) {
      errors.Message = `Message must be ${MAX_MESSAGE_LENGTH} characters or less`;
    }

    if (!demoTurnstileToken) {
      errors.Turnstile = "Please complete the verification challenge";
    }

    // if (!demoPhoneNumber || demoPhoneNumber.trim().length === 0) {
    //   errors.PhoneNumber = "Please enter your phone number.";
    // }

    setDemoErrors(errors);
    return Object?.keys(errors)?.length > 0;
  };

  const handleSubmitDemoRequest = () => {
    if (ValidateDemoRequestDate()) return;

    setIsSubmitLoading(true);
    const payload = {
      FullName: demoFullName,
      CompanyName: demoCompanyName,
      PhoneNumber: demoPhoneNumber,
      Email: demoEmail,
      DemoDateTime: demoDateTime ? moment(demoDateTime).utc().format() : null,
      Tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      Message: demoMessage || null
    };

    api.DemoRequest(payload, { [TURNSTILE_TOKEN_HEADER]: demoTurnstileToken }).then(() => {
      setIsDemoRequestCompleted(true);
    }).catch(() => {
      setIsSubmitLoading(false);
    })
    .finally(() => {
      setIsSubmitLoading(false);
      // Turnstile tokens are single-use; reset so a retry gets a fresh one.
      setDemoTurnstileToken(null);
      demoTurnstileRef.current?.reset();
    });

  };

  const handleDemoDateTimeChange = (date) => {
    if (!date) {
      setDemoDateTime(null);
      setDemoErrors((prevErrors) => ({
        ...prevErrors,
        DateTime: "",
      }));
      return;
    }

    const hours = moment(date).hours();
    const minutes = moment(date).minutes();
    
    // Validate time range
    if (hours < MIN_HOUR || hours >= MAX_HOUR) {
      setDemoErrors((prevErrors) => ({
        ...prevErrors,
        DateTime: `Please select a time between ${MIN_HOUR}:00 and ${MAX_HOUR}:00`,
      }));
      return;
    }

    // Check if the selected date/time is in the past
    if (moment(date).isBefore(moment())) {
      setDemoErrors((prevErrors) => ({
        ...prevErrors,
        DateTime: "Please select a future date and time",
      }));
      return;
    }

    setDemoDateTime(date);
    setDemoErrors((prevErrors) => ({
      ...prevErrors,
      DateTime: "",
    }));
  };

  const handleDemoMessageChange = (e) => {
    const value = e.target.value;
    if (value.length <= MAX_MESSAGE_LENGTH) {
      setDemoMessage(value);
      setDemoErrors((prevErrors) => ({
        ...prevErrors,
        Message: "",
      }));
    }
  };

  const filterPassedTime = (time) => {
    const selectedDate = demoDateTime || new Date();
    const currentDate = new Date();
    const selectedTime = new Date(time);
    
    const hours = selectedTime.getHours();
    
    // Filter out times outside business hours (8 AM to 6 PM)
    if (hours < MIN_HOUR || hours >= MAX_HOUR) {
      return false;
    }
    
    // If selected date is today, filter out past times
    if (moment(selectedDate).isSame(currentDate, 'day')) {
      return currentDate.getTime() < selectedTime.getTime();
    }
    
    return true;
  };

  const filterDate = (date) => {
    const day = date.getDay();
    // Disable past dates and weekends (0 = Sunday, 6 = Saturday)
    return moment(date).isSameOrAfter(moment(), 'day') && day !== 0 && day !== 6;
  };

  return (
    <div className={Style.mainWrapper}>
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="w-full flex justify-center max-h-screen">
          <img src={HanshiLogin} alt="Login" className="w-full max-w-2xl md:max-w-4xl" />
          <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-[#0C0F1C] via-[#0C0F1C]/60 to-transparent"></div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <div className={`${Style.card} sm:max-w-sm md:max-w-md lg:max-w-ld xl:max-w-xl`}>
          {isCompanyName ? (
            <div className={Style.cardContent}>
              {/* {logo ? 
              <div className={Style.accountLogoContainer}>
                <img src={logo}/>
              </div>
              : ''} */}

              <div className={Style.cardTitleContainer}>
                <p className={`${Style.cardTitle} text-xl-700`}>
                  Log In
                </p>
              </div>
              <div>
                <div className={Style.emailFieldWrapper}>
                  <p className={`${Style.cardDescription} text-sm-500`}>Email or Username</p>
                  <CustomInput
                    inputClass={Style.loginInput}
                    icon={false}
                    type="email"
                    errorMessage={emailError}
                    handleChange={setEmail}
                    onKeyDown={handleKeyDown}
                    value={email}
                  />
                </div>
                <div className={Style.emailFieldWrapper}>
                  <p className={`${Style.cardDescription} text-sm-500`}>Password</p>
                  <CustomInput
                    inputClass={Style.loginInput}
                    dir={true}
                    icon={true}
                    type="password"
                    handleChange={setPassword}
                    onKeyDown={handleKeyDown}
                    value={password}
                  />
                </div>
                <div className="row align-items-center">
                  <div className={`${Style.loginCheckboxWrapper} col`}>
                    <Checkbox

                      label="Remember me"
                      setChecked={handleCheckboxChange}
                      checked={checked}
                    />
                  </div>
                  <div className="col">
                    <ForgotButton
                      label="Forgot password?"
                      handleClick={handleForgotPassword}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) :
            !isDemoMode ?
              (
                <div className={Style.cardContent}>
                  {/* <div className={Style.cardTitleContainer}>
                <p className={`${Style.cardTitle} text-xl-700`}>
                  To sign in
                </p>
                <p className={`${Style.cardDescription} text-sm-500`}>
                  Enter your Organization's Hanshi Domain
                </p>
              </div> */}
                  <div>
                    <div className={Style.emailFieldWrapper}>
                      <CustomInput
                        icon={false}
                        label="Organization Domain"
                        labelClass={Style.demoLabels}
                        inputClass={Style.loginInput}
                        type="text"
                        errorMessage={companyNameError}
                        handleChange={setCompanyName}
                        onKeyDown={handleKeyDownCompanyName}
                        value={companyName}
                      />
                    </div>
                  </div>
                </div>
              ) :
              (!isDemoRequestCompleted ?
                <div className={Style.cardContent}>
                  <div className={Style.cardTitleContainer}>
                    <p className={`${Style.cardTitle} text-xl-700`}>
                      Request a demo
                    </p>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className={`col-sm-12 col-md ${Style.mbsm3}`}>
                      <CustomInput
                        inputClass={Style.loginInput}
                        labelClass={Style.demoLabels}
                        isRequired
                        icon={false}
                        label="Full Name"
                        type="text"
                        errorMessage={demoErrors["FullName"]}
                        handleChange={setDemoFullName}
                        value={demoFullName}
                      />
                    </div>
                    <div className="col-sm-12 col-md">
                      <CustomInput
                        inputClass={Style.loginInput}
                        labelClass={Style.demoLabels}
                        isRequired
                        icon={false}
                        label="Company Name"
                        type="text"
                        errorMessage={demoErrors["CompanyName"]}
                        handleChange={setDemoCompanyName}
                        value={demoCompanyName}
                      />
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className={`col-sm-12 col-md ${Style.mbsm3}`}>
                      <CustomInput
                        inputClass={Style.loginInput}
                        labelClass={Style.demoLabels}
                        isRequired
                        icon={false}
                        label="Work Email"
                        type="email"
                        handleBlur={(e) => validateEmail(e)}
                        errorMessage={demoErrors["Email"]}
                        handleChange={handleDemoEmailChange}
                        value={demoEmail}
                      />
                    </div>
                    <div className="col-sm-12 col-md">
                      <Phone
                        phoneWd={` ${Style.demoPhoneWrapper} demoPhoneInput`}
                        label="Phone Number"
                        placeholder=""
                        labelClass={Style.demoLabels}
                        errorMessage={demoErrors["PhoneNumber"]}
                        handleChange={setDemoPhoneNumber}
                        value={demoPhoneNumber}
                      />
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-sm-12">
                      <div className={Style.emailFieldWrapper}>
                        <label className={`${Style.demoLabels} ${demoErrors["DateTime"] ? Style.errorLabel : ''}`}>
                          Preferred Demo Time
                          <span class="Input_staric">*</span>
                        </label>
                        <DatePicker
                          selected={demoDateTime}
                          onChange={handleDemoDateTimeChange}
                          showTimeSelect
                          timeFormat={"HH:mm"}
                          timeIntervals={15}
                          dateFormat={`MMMM d, yyyy HH:mm`}
                          minDate={new Date()}
                          minTime={moment().hours(MIN_HOUR).minutes(0).toDate()}
                          maxTime={moment().hours(MAX_HOUR - 1).minutes(45).toDate()}
                          filterDate={filterDate}
                          filterTime={filterPassedTime}
                          className={`${Style.dateLoginInput} ${demoErrors["DateTime"] ? Style.errorInput : ''}`}
                          placeholderText={`Select demo time`}
                          timeCaption="Time"
                          popperClassName="react-datepicker-popper"
                          popperPlacement="bottom-start"
                          showDisabledMonthNavigation
                          strictParsing
                          onChangeRaw={(e) => e.preventDefault()}
                        />
                        {demoErrors["DateTime"] && (
                          <p class="Input_errorMessage">{demoErrors["DateTime"]}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-sm-12">
                      <div className={Style.emailFieldWrapper}>
                        <label className={`${Style.demoLabels} ${demoErrors["Message"] ? Style.errorLabel : ''}`}>
                          
                        </label>
                        <textarea
                          className={`${Style.demoTextarea} ${demoErrors["Message"] ? Style.errorInput : ''}`}
                          rows="4"
                          placeholder="Tell us more about your needs..."
                          value={demoMessage}
                          onChange={handleDemoMessageChange}
                          maxLength={MAX_MESSAGE_LENGTH}
                        />
                        <div className="d-flex justify-content-between align-items-center mt-1">
                          {demoErrors["Message"] && (
                            <p class="Input_errorMessage mb-0">{demoErrors["Message"]}</p>
                          )}
                          <span className={`text-xs ${Style.charCount}`}>
                            {demoMessage.length}/{MAX_MESSAGE_LENGTH}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center gx-3 mb-3">
                    <div className="col-sm-12">
                      <Turnstile
                        ref={demoTurnstileRef}
                        mode="visible"
                        onVerify={setDemoTurnstileToken}
                        onExpire={() => setDemoTurnstileToken(null)}
                        onError={() => setDemoTurnstileToken(null)}
                      />
                      {demoErrors["Turnstile"] && (
                        <p class="Input_errorMessage">{demoErrors["Turnstile"]}</p>
                      )}
                    </div>
                  </div>
                </div>
                :
                <div className={Style.cardContent}>
                  <div className={Style.cardTitleContainer}>
                    <p className={`${Style.cardTitle} text-xl-700`}>
                      We have received your request.
                    </p>
                    <br />
                    <p className={`${Style.cardTitle} text-xl-600`}>
                     A member of our team will contact you shortly.
                    </p>
                  </div>
                </div>
              )

          }
          {isCompanyName ?
            <div>
              <Button
                btnClass="btn_w100 btn_w100_primary"
                label="Login"
                clickHandler={(e) => handleLogin(e)}
                showLoading={isLoading}
                isDisabled={disabled}
              />
              <div
                className="d-flex justify-content-between align-items-center"
              >
                <p
                  className="my-3 mx-2 text-xsm-500 text-[#5e5e5e] hover:text-[#5b5fc7] hover:cursor-pointer"
                  onClick={() => handleRemoveCookie()}>
                  Access another organization account?
                </p>
              </div>
            </div>
            :
            isDemoMode ?
              <div>
                {!isDemoRequestCompleted && <Button
                  btnClass="btn_w100 btn_w100_primary"
                  label="Submit"
                  showLoading={isSubmitLoading}
                  clickHandler={() => handleSubmitDemoRequest()}
                />}
                <div
                  className="d-flex align-items-center"
                  onClick={() => toggleDemoMode()}
                >
                  <ArrowLeft />
                  <p className="my-3 text-xsm-500 text-[#5e5e5e] hover:text-[#342c82] hover:cursor-pointer">
                    Back to Sign In
                  </p>
                </div>
              </div>
              :
              <div>
                <Button
                  btnClass="btn_w100 btn_w100_primary"
                  label="Continue"
                  clickHandler={() => handleCompanyName()}
                  isDisabled={companyName == ""}
                />
                <div
                  className="d-flex justify-content-between align-items-center"
                  onClick={() => toggleDemoMode()}
                >
                  <p className="my-3 mx-2 text-xsm-500 text-[#5e5e5e] hover:text-[#342c82] hover:cursor-pointer">
                    Not registered? Request a demo.
                  </p>
                </div>
              </div>
          }


        </div>
      </div>
    </div>
  );
};

export default Login;
